import * as yup from 'yup'
import { PHONE_NUMBER_REGEX } from '@/shared/config/constants'
import { MAXIMUM_IMAGE_SIZE } from '@/shared/utils/imageUploadUtility'

const parentSchema = yup.object({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    password: yup
        .string()
        .required('Password is required')
        .min(6, 'Password must be at least 6 characters'),
    relationship: yup.string().required('Relationship is required'),
    address: yup.string().min(6, 'Address must be at least 6 characters'),
    branch: yup
        .object({
            value: yup.string(),
            label: yup.string()
        })
        .required('Branch is required'),
    phoneNumber: yup
        .string()
        .matches(PHONE_NUMBER_REGEX, 'Phone number is not valid')
        .required('Phone Number is required'),
    picture: yup
        .mixed()
        .required()
        .test('noImage', 'Image is required', (value: any) => {
            return value && value[0]?.size
        })
        .test('fileSize', 'The file is too large', (value: any) => {
            return value && value[0]?.size <= MAXIMUM_IMAGE_SIZE
        })
})

export default parentSchema
